<template>
    <svg class="category-icon" width="100%" height="100%" viewBox="0 0 68 68" version="1.1" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:10;">
        <path d="M3.76,3.76L63.92,3.76L41.36,30.08L41.36,52.64L26.32,63.92L26.32,30.08L3.76,3.76Z" style="fill:none;fill-rule:nonzero;stroke:rgb(23,93,59);stroke-width:7.52px;"/>
    </svg>
</template>

<script>
export default {
    name: "CategoryIcon"
}
</script>
